__webpack_require__.i.push(function(options) {
	var originalFactory = options.factory;
	options.factory = function(moduleObject, moduleExports, webpackRequire) {
		__webpack_require__.$Refresh$.setup(options.id);
		try {
			originalFactory.call(this, moduleObject, moduleExports, webpackRequire);
		} finally {
			if (moduleObject.exports instanceof __webpack_require__.g.Promise) {
				options.module.exports.then(
					function(result) {
						__webpack_require__.$Refresh$.cleanup(options.id);
						return result;
					},
					function(reason) {
						__webpack_require__.$Refresh$.cleanup(options.id);
						return Promise.reject(reason);
					}
				);
			} else {
				__webpack_require__.$Refresh$.cleanup(options.id)
			}
		}
	}
})

__webpack_require__.$Refresh$ = {
	register: function() { return undefined; },
	signature: function() { return function(type) { return type; }; },
	setup: function(currentModuleId) {
		var prevModuleId = __webpack_require__.$Refresh$.moduleId;
		var prevRuntime = __webpack_require__.$Refresh$.runtime;
		var prevRegister = __webpack_require__.$Refresh$.register;
		var prevSignature = __webpack_require__.$Refresh$.signature;
		var prevCleanup = __webpack_require__.$Refresh$.cleanup;

		__webpack_require__.$Refresh$.moduleId = currentModuleId;

		__webpack_require__.$Refresh$.runtime = {
			createSignatureFunctionForTransform: function() { return function(type) { return type; }; },
			register: function() { return undefined; }
		};

		__webpack_require__.$Refresh$.register = function(type, id) {
			var typeId = currentModuleId + " " + id;
			__webpack_require__.$Refresh$.runtime.register(type, typeId);
		}

		__webpack_require__.$Refresh$.signature = __webpack_require__.$Refresh$.runtime.createSignatureFunctionForTransform;

		__webpack_require__.$Refresh$.cleanup = function(cleanupModuleId) {
			if (currentModuleId === cleanupModuleId) {
				__webpack_require__.$Refresh$.moduleId = prevModuleId;
				__webpack_require__.$Refresh$.runtime = prevRuntime;
				__webpack_require__.$Refresh$.register = prevRegister;
				__webpack_require__.$Refresh$.signature = prevSignature;
				__webpack_require__.$Refresh$.cleanup = prevCleanup;
			}
		}
	}
};